import classnames from 'classnames'
import * as React from 'react'

import { Button } from '../button'
import { useNotification } from './hooks'

interface NotificationProps {
  className?: string
  actions?: JSX.Element
  timeoutInMs?: number
}

export function Notification(props: React.PropsWithChildren<NotificationProps>) {
  const notification = useNotification()

  React.useEffect(() => {
    let timeoutId: NodeJS.Timeout
    if (props.timeoutInMs) {
      timeoutId = setTimeout(() => {
        notification.hide()
      }, props.timeoutInMs)
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [notification, props.timeoutInMs])

  return (
    <div
      className={classnames(
        props.className,
        'pointer-events-auto flex space-x-4 rounded-md border border-transparent bg-gray-800 px-3 py-2 shadow-modal dark:border-gray-600 dark:shadow-modal-dark'
      )}
    >
      <div className="text-left text-white">{props.children}</div>
      <div>{props.actions ?? <Button onClick={notification.hide}>Close</Button>}</div>
    </div>
  )
}
